import { render, staticRenderFns } from "./MultipleConsigneesModal.vue?vue&type=template&id=a2712752&scoped=true"
import script from "./MultipleConsigneesModal.vue?vue&type=script&lang=js"
export * from "./MultipleConsigneesModal.vue?vue&type=script&lang=js"
import style0 from "./MultipleConsigneesModal.vue?vue&type=style&index=0&id=a2712752&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2712752",
  null
  
)

export default component.exports